import { motion } from 'framer-motion';
import { ShieldCheck, Truck, Shield, Award } from 'lucide-react';

const certifications = [
  { label: 'MC Number', value: 'MC-1394566', icon: ShieldCheck },
  { label: 'DOT Number', value: 'DOT-3837808', icon: Truck },
  { label: 'Cargo Insurance', value: '$100,000', icon: Shield },
  { label: 'General Liability', value: '$1,000,000', icon: Award },
];

export const CertificationsSection = () => (
  <section className="py-24 bg-black" style={{ fontFamily: 'Outfit, sans-serif' }}>
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-14">
        <span className="text-red-500 text-xs font-bold uppercase tracking-[0.25em]">Licensed & Insured</span>
        <h2 className="text-3xl sm:text-4xl font-black text-white mt-3 tracking-tight">
          Credentials You Can Verify
        </h2>
        <p className="text-zinc-500 mt-3 max-w-lg mx-auto" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
          Registered with the Federal Motor Carrier Safety Administration. 
          Full documentation available upon request.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
        {certifications.map((cert, i) => (
          <motion.div
            key={cert.label}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.1 }}
            className="bg-zinc-950 border border-zinc-800 p-6 text-center hover:border-zinc-700 transition-colors"
          >
            <cert.icon className="w-8 h-8 text-red-500 mx-auto mb-3" strokeWidth={1.5} />
            <div className="text-[10px] text-zinc-500 uppercase tracking-widest mb-2">{cert.label}</div>
            <div className="text-xl font-black text-white tracking-tight" style={{ fontFamily: 'JetBrains Mono, Outfit, monospace' }}>{cert.value}</div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
